/* eslint-disable object-curly-spacing */ 
/* eslint-disable no-undef */ 
/* eslint-disable own-handles */ 
/* eslint-disable no-innerhtml-assign */ 
/* eslint-disable consistent-method-names */ 
/* eslint-disable no-jsdoc */ 
define(['leaflet', './addressContainer'], function(L, addressContainer) {
    'use strict';
    return function(data) {
        var div = L.DomUtil.create('div', 'tomtom-point-content__address');

        if (data.address) {
            div.appendChild(addressContainer(data.address));
        } else {
            data.getAddress().then(function(data) {
                div.appendChild(addressContainer(data.address));
            });
        }
        return div;
    };
});



// WEBPACK FOOTER //
// ./services/popupContentGenerator/details/addressContent.js